import {
  GetPermissionsResponse,
  ResetPasswordRequest,
  TUser,
  UserCreateRequest,
  UserCreateResponse,
} from "@/types/userTypes";
import {createApi, FetchArgs} from "@reduxjs/toolkit/query/react";
import platformAuthConfig from "./platformConfig";

export type TagTypes = "Users";

const adminApi = createApi({
  reducerPath: "adminApi",
  ...platformAuthConfig(),
  tagTypes: ["Users"],
  endpoints: (builder) => ({
    addUser: builder.mutation<UserCreateResponse, UserCreateRequest>({
      query: (config): FetchArgs => ({
        url: "/admin/create_user",
        method: "POST",
        body: config,
      }),
      invalidatesTags: ["Users"],
    }),
    deleteUser: builder.mutation<void, string>({
      query: (user_id): FetchArgs => ({
        url: `/admin/users/${user_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Users"],
    }),
    getUsers: builder.query<TUser[], void>({
      query: (): FetchArgs => ({
        url: "/admin/list_users",
        method: "GET",
      }),
      providesTags: ["Users"],
    }),
    getCurrentUser: builder.query<TUser, void>({
      query: (): FetchArgs => ({
        url: "/authentication/user_info",
        method: "GET",
      }),
    }),
    resetPassword: builder.mutation<void, ResetPasswordRequest>({
      query: (config): FetchArgs => ({
        url: "/authentication/change-password",
        method: "POST",
        body: config,
      }),
    }),
    getPermissions: builder.query<GetPermissionsResponse, void>({
      query: (): FetchArgs => ({
        url: "/admin/get_permissions",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddUserMutation,
  useGetUsersQuery,
  useGetCurrentUserQuery,
  useDeleteUserMutation,
  useResetPasswordMutation,
  useGetPermissionsQuery,
} = adminApi;

export default adminApi;
